// @flow

/**
 * Unescapes HTML strings within the text.
 *
 * @param {string} text - The text to unescape
 */
const unescapeHtml = (text?: string) => {
  if (!text) {
    return '';
  }
  return text.replace(/&lt;|&gt;|&amp;|&quot;|&#39;|&#x60;/g, match => {
    const escape = {
      '&lt;': '<',
      '&gt;': '>',
      '&amp;': '&',
      '&quot;': '"',
      '&#39;': "'",
      '&#x60;': '`', // Apparently some IE versions use this character to quote attributes
    };
    return escape[match];
  });
};

export default unescapeHtml;
